import { z } from "zod";
import { NAME } from "../consts";

export const schema = z.object({
  [NAME]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
